import React from "react";
import Typography from "@mui/material/Typography";

const RequiredLabel = () => {
  return (
    <Typography
      variant="body2"
      style={{ display: "inline", whiteSpace: "nowrap", color: "red" }}
    >
      ［必須］
    </Typography>
  );
};

export default RequiredLabel;
